import * as moment from 'moment'

export const removeNamespace = (namespace, types) => {
  const typeKeys = Object.keys(types)
  return Object.values(types).reduce((typeObj, typeValue, j) => {
    const typeObjectKeys = Object.keys(typeValue)
    typeObj[typeKeys[j]] = Object.values(typeValue).reduce((obj, v, k) => {
      obj[typeObjectKeys[k]] = v.replace(namespace + '/', '')
      return obj
    }, {})
    return typeObj
  }, {})
}

export const fillArrayTo = (i, startFrom = 0, zeroBase = false) => {
  const diff = i - startFrom
  return new Array(diff)
    .fill(null)
    .map((v, i) => {
      const val = (!zeroBase) ? i + 1 : i
      return startFrom + val
    })
}

export const formatDate = (date, format) => {
  return moment(date).format(format)
}

export const randomIntFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export const groupBy = (collection, key) => {
  return collection.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

export const handleLinkClick = (link) => {
  if (link && link.url) {
    if (link.target) {
      window.open(link.url, link.target)
    } else {
      window.location = link.url
    }
  }
}

export const sanitizeVideoLink = (link) => {
  const vimeoRegex = /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/
  if (link.match(vimeoRegex)) {
    // is vimeo link
    const split = link.split('/')
    const id = split[split.length - 1]
    return `https://player.vimeo.com/video/${id}`
  }

  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = link.match(regExp)
  if (match && match[2].length === 11) {
    // is youtube link
    return `//www.youtube.com/embed/${match[2]}`
  }

  // is neither, it is up to the user on contentful to provide a valid src link
  return link
}

export const backgroundColorClass = (field) => {
  let color
  // Did not want the names in CTF to be light-gray or error
  switch (field) {
  case 'orange':
    color = 'error'
    break
  case 'gray':
    color = 'light-gray'
    break
  case 'gold':
    color = 'gold'
    break
  case 'white':
    color = 'white'
    break
  case 'off white pattern':
    color = 'off-white-pattern'
    break
  case 'gold pattern':
    color = 'gold-pattern'
    break
  case 'gray pattern':
    color = 'gray-pattern'
    break
  case 'blue pattern':
    color = 'blue-pattern'
    break
  case 'dark blue pattern':
    color = 'dark-blue-pattern'
    break
  case 'blue':
    color = 'primary'
    break
  case 'dark blue':
    color = 'info'
    break
  case 'purple':
    color = 'warning'
    break
  case 'green':
    color = 'accent'
    break
  default:
    color = 'light-gray'
    break
  }
  return color
}

export const backgroundLightColorClass = (field) => {
  let color
  switch (field) {
  case 'orange':
    color = 'light-error'
    break
  case 'gold':
    color = 'light-gold'
    break
  case 'blue':
    color = 'light-primary'
    break
  case 'dark blue':
    color = 'light-info'
    break
  case 'purple':
    color = 'light-warning'
    break
  case 'green':
    color = 'light-accent'
    break
  default:
    color = 'light-primary'
    break
  }
  return color
}

export const textColorClass = (backgroundColor) => {
  let color
  // Did not want the names in CTF to be light-gray or error
  switch (backgroundColor) {
  case 'orange':
    color = 'true-black--text'
    break
  case 'gray':
  case 'gold':
    color = 'secondary--text'
    break
  case 'off white pattern':
    color = ''
    break
  case 'gold pattern':
  case 'gray pattern':
    color = 'secondary--text'
    break
  case 'blue pattern':
  case 'dark blue pattern':
  case 'blue':
  case 'dark blue':
  case 'purple':
  case 'green':
    color = 'white--text'
    break
  default:
    color = ''
    break
  }
  return color
}

export const leftBarColorClass = (backgroundColor) => {
  let color
  switch (backgroundColor) {
  case 'Dark Blue':
    color = 'secondary'
    break
  case 'Light Blue':
    color = 'primary'
    break
  case 'Gold':
    color = 'gold'
    break
  case 'Orange':
    color = 'error'
    break
  default:
    color = ''
    break
  }
  return color
}
